export const trailPinImageName = 'trail-pin';
export const trailPinActiveImageName = 'trail-pin-active';
export const trailPinClosedImageName = 'trail-pin-closed';
export const trailPinClosedActiveImageName = 'trail-pin-closed-active';
export const multiTrailPinImageNameBase = 'trail-pin-';
export const multiTrailPinActiveImageNameBase = 'trail-pin-active-';
export const multiTrailPinClosedImageNameBase = 'trail-pin-closed-';
export const multiTrailPinClosedActiveImageNameBase = 'trail-pin-closed-active-';
export const multiTrailPinSavedImageNameBase = 'trail-pin-saved-';
export const multiTrailPinSavedActiveImageNameBase = 'trail-pin-saved-active-';
export const multiTrailPinCompletedImageNameBase = 'trail-pin-completed-';
export const multiTrailPinCompletedActiveImageNameBase = 'trail-pin-completed-active-';
export const trailPinSavedImageName = 'trail-pin-saved';
export const trailPinSavedActiveImageName = 'trail-pin-saved-active';
export const trailPinCompletedImageName = 'trail-pin-completed';
export const trailPinCompletedActiveImageName = 'trail-pin-completed-active';
export const trailPinCollapsedImageName = 'trail-pin-collapsed';
export const trailPinCollapsedClosedImageName = 'trail-pin-collapsed-closed';
export const trailPinCollapsedSavedImageName = 'trail-pin-collapsed-saved';
export const trailPinCollapsedCompletedImageName = 'trail-pin-collapsed-completed';
export const trailPinCollapsedViewedImageName = 'trail-pin-collapsed-viewed';
export const isMultiTrailExpression = ['>', ['get', 'trailCount'], 1];
export const isTrailClosedExpression = ['==', ['get', 'isClosed'], true];
export const isTrailSavedExpression = ['==', ['get', 'isSaved'], true];
export const isTrailCompletedExpression = ['==', ['get', 'isCompleted'], true];
export const isTrailCollapsedExpression = ['==', ['get', 'isCollapsed'], true];
